<script setup lang="ts">
import type { ICreditTypes } from '~/components/widget/select-credit-type'
import type { IResponseData } from '~/types'
import type { IProps } from '~/components/entity/credit'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/credit_types', { ...props.queryParams }))
const { data } = useApi<IResponseData<ICreditTypes[]>>(() => url, {
  key: 'credit-types-sidebar-widget'
})
const credits = computed(() => {
  return data.value?.data.map((i) => {
    return {
      title: i.title,
      url: `/credits/${i.slug}`,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="credits?.length"
    :heading-text="$t('common.loan_selection')"
    variant="white"
    heading-tag="h2"
  >
    <SidebarMenu :menu-items="credits" />
  </SidebarBlock>
</template>
